import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/auth";
import "./Header.scss";

const Header = ({ onMenuClick }) => {
	const { userBase, signOut } = useAuth();
	const [dropdownVisible, setDropdownVisible] = useState(false);
	const dropdownRef = useRef(null);

	const handleDropdownToggle = () => {
		setDropdownVisible((prev) => !prev);
	};

	const handleLogout = (event) => {
		event.stopPropagation();
		signOut();
		setDropdownVisible(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownVisible(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<header className="header">
			<button onClick={onMenuClick} className="menu-button" type="button">
				Навигация
			</button>

			<div ref={dropdownRef} className="user" onClick={handleDropdownToggle}>
				<span className="user__icon">Админ</span>
				<span>{userBase?.fullName || userBase?.login || "Модератор"}</span>

				<div
					className={`logout ${dropdownVisible ? "visible" : ""}`}
					onClick={(event) => event.stopPropagation()}
				>
					<button onClick={handleLogout} type="button">
						Выйти
					</button>
				</div>
			</div>
		</header>
	);
};

export default Header;
